export const CHECKOUT_URL = 'https://welding.impultienda.ar/checkout/'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/p83JtqGpJppn8xmdSmJN7M/SOLDADURA-EN.png'

export const INSTRUCTOR_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/de9856ce-e413-498a-8f6c-b992de8d485c.jpg'

export const WELD_BEAD_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/87427007-1122-40f7-8b3d-83625f5add9c.jpg'

export const PRICE = {
  today: '$27',
  totalValue: '$737',
  manualsValue: '$492',
  bonusValue: '$245',
}

export const stats = [
  { value: '+300', label: 'Practical solutions' },
  { value: '+1,200', label: 'Welders' },
  { value: '6', label: 'Master manuals' },
  { value: '99%', label: 'Recommend it' },
]

export const beforeItems = [
  'You waste material because your machine settings aren’t right.',
  'You guess the amperage every time the material thickness changes.',
  'Your weld beads look different from one practice session to the next.',
  'You aren’t sure whether your weld will actually hold.',
  'Every new project starts with uncertainty and guesswork.',
]

export const afterItems = [
  'You’ll know what to check before you start welding.',
  'You’ll work toward cleaner, stronger and more consistent welds.',
  'You’ll reduce wasted electrodes and material.',
  'You’ll identify and correct common welding mistakes faster.',
  'You’ll weld with the confidence that comes from having a clear process.',
]

export const forYouItems = [
  'You own a welder but never properly learned how to use it.',
  'You learn from YouTube, but every video seems to recommend something different.',
  'You constantly question your settings before starting a weld.',
  'You waste electrodes and material because of avoidable mistakes.',
  'You want to build your own projects with confidence.',
  'You want to handle repairs without always depending on someone else.',
  'You want your welds to look cleaner, more consistent and professional.',
]

export const manuals = [
  {
    number: '01',
    title: 'Method Zero Errors™',
    description:
      'Learn what to check before welding so you can avoid the most common mistakes from the beginning.',
  },
  {
    number: '02',
    title: 'Total Arc Control™',
    description:
      'Improve your welding technique to produce cleaner, more consistent and stronger weld beads.',
  },
  {
    number: '03',
    title: 'Master Configuration Code™',
    description:
      'Learn how to configure your welder correctly without constantly guessing your settings.',
  },
  {
    number: '04',
    title: 'Welding Without Limits™',
    description:
      'Learn how to approach different welding positions with greater control and confidence.',
  },
  {
    number: '05',
    title: 'Welder’s Diagnostic Lab™',
    description:
      'Identify common weld defects and understand what to adjust instead of repeating the same mistake.',
  },
  {
    number: '06',
    title: 'Professional Finish™',
    description:
      'Improve cleaning, grinding and finishing so your completed projects look cleaner and more professional.',
  },
]

export const included = [
  {
    icon: 'BookOpen',
    title: '6 Master Manuals',
    description:
      'Complete digital manuals designed for practical consultation while you’re learning and welding.',
  },
  {
    icon: 'Zap',
    title: '300+ Practical Solutions',
    description:
      'Clear, practical solutions organized around the problems you’re most likely to encounter in the workshop.',
  },
  {
    icon: 'Table',
    title: 'Quick-Reference Configuration Tables',
    description:
      'Easy-to-consult tables designed to help you make better decisions before striking the arc.',
  },
  {
    icon: 'Search',
    title: 'Visual Error-Diagnosis Guides',
    description:
      'Identify common welding problems and understand what to adjust instead of repeating the same mistake.',
  },
  {
    icon: 'ListChecks',
    title: 'Quick-Reference Checklists',
    description:
      'Simple checklists you can use before, during and after your welding sessions.',
  },
  {
    icon: 'Smartphone',
    title: 'Access From Any Device',
    description:
      'Use the manuals from your phone, tablet or computer whenever you need them.',
  },
]

export const bonuses = [
  {
    number: '#1',
    title: 'Welder’s Cost Center™',
    headline: 'Know exactly what each welding job is costing you.',
    description:
      'Stop guessing how much to charge. Learn how to calculate materials, electrodes, electricity, labor and other project costs so you can price your work with confidence.',
    value: '$47',
    featured: false,
    image:
      'https://cdn.magicpatterns.com/uploads/qpdQ1nGTtkUcQ1E9SFud49/BONUS_1_SOLDADURA-EN.png',
  },
  {
    number: '#2',
    title: 'Premium Finish™',
    headline: 'Make your projects look like they came from a professional workshop.',
    description:
      'Learn the finishing details that make a major difference: cleaning, grinding, painting and presentation so your completed projects look more polished and professional.',
    value: '$37',
    featured: false,
    image:
      'https://cdn.magicpatterns.com/uploads/d1b2eFz2CZHDvu3ct4JG4o/BONUS_2_SOLDADURA-EN.png',
  },
  {
    number: '#3',
    title: 'Weld Bead Library™',
    headline: 'Compare, identify and correct any welding defect.',
    description:
      'Use a visual reference library with 100+ photo examples to compare your welds, identify what went wrong and understand what to adjust instead of wasting more material.',
    value: '$67',
    featured: true,
    image:
      'https://cdn.magicpatterns.com/uploads/8XN1uKfumgVxTsDA9JX6dF/BONUS_3_SOLDADURA-EN.png',
  },
  {
    number: '#4',
    title: 'Client Getting Master Kit™',
    headline: 'Turn your welding skills into real income.',
    description:
      'Get practical templates, messages and strategies to help you present your services, respond to potential customers and start getting more welding jobs.',
    value: '$57',
    featured: false,
    image:
      'https://cdn.magicpatterns.com/uploads/g3HNMdUzTXdjwYeEzmWQjW/BONUD_4_SOLDADURA-EN.png',
  },
  {
    number: '#5',
    title: 'Professional Workshop Audit™',
    headline: 'Build an image that makes customers trust your work.',
    description:
      'Identify the small details that can make your workshop and your service look less professional, then learn how to create a stronger first impression.',
    value: '$37',
    featured: false,
    image:
      'https://cdn.magicpatterns.com/uploads/vU2SEdG26hPD9VYzCEpUAz/BONUS_5_SOLDADURA-EN.png',
  },
]

export const testimonials = [
  {
    name: 'Carlos M.',
    role: 'Welder',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ec6cf909-d790-4364-b404-afa263c4164f.jpg',
    quote:
      'I had owned my welder for two years and was always guessing the amperage. The configuration tables made it much easier to know where to start, and I stopped wasting so many electrodes.',
  },
  {
    name: 'Nahuel R.',
    role: 'DIY Welder',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e3803840-805e-424a-b229-d733fcb80346.jpg',
    quote:
      'I used to learn everything from YouTube, but every video seemed to say something different. Having everything organized in one place makes it much easier to follow.',
  },
  {
    name: 'Diego F.',
    role: 'Independent Welder',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0e791aa6-667f-42a2-8bdd-51ddc8864f6d.jpg',
    quote:
      'The visual troubleshooting section is incredibly useful. Now I can look at a weld, identify the problem and know what I need to adjust instead of starting over blindly.',
  },
]

export const faqs = [
  {
    question: 'How will I receive Master Welding System™?',
    answer:
      'Immediately after your payment, you’ll receive an email with access to the 6 Master Manuals and 5 Exclusive Bonuses in digital format.',
  },
  {
    question: 'Does it work if I’ve never welded before?',
    answer:
      'Yes. The system is designed to give beginners a clear reference point and help them avoid many of the common mistakes that come from learning through trial and error.',
  },
  {
    question: 'What if I already have welding experience?',
    answer:
      'It’s useful for experienced welders too. Instead of relying on memory or searching for information, you can use the manuals as a quick reference whenever you need to check a setting, diagnose a problem or review a technique.',
  },
  {
    question: 'Do I need internet access?',
    answer:
      'You need internet access to receive and download the digital files. Once downloaded, you can use the manuals offline on your device.',
  },
  {
    question: 'Is this a one-time payment?',
    answer:
      'Yes. You pay once and receive lifetime access. There are no monthly subscriptions or recurring charges.',
  },
  {
    question: 'What happens if I don’t like it?',
    answer:
      'You’re protected by our 7-Day Satisfaction Guarantee. If you decide it’s not right for you, contact us within 7 days and we’ll refund your purchase.',
  },
]

export const purchaseNotifications = [
  { name: 'Miguel A.', country: 'Mexico' },
  { name: 'Javier P.', country: 'Spain' },
  { name: 'Lucas D.', country: 'Argentina' },
  { name: 'Andrés G.', country: 'Colombia' },
  { name: 'Rodrigo S.', country: 'Chile' },
  { name: 'Fernando T.', country: 'Peru' },
  { name: 'Kevin R.', country: 'Ecuador' },
  { name: 'Josué M.', country: 'Guatemala' },
  { name: 'Wilson C.', country: 'Venezuela' },
  { name: 'Marcos B.', country: 'Uruguay' },
  { name: 'Elías N.', country: 'Costa Rica' },
  { name: 'Ramón V.', country: 'Dominican Republic' },
]
